import React from 'react';
import StoreFooter from '../../NewStoreHomeWeb/StoreFooterNew/StoreFooter';
import { FooterContainer } from '../../Product/PdpHeader/styled';

export default function findex(props) {
  let {
    content,
    faqsData,
    priceRateMerge,
    alsoSearchFor,
    showHeader,
    screen,
    bottomRef,
    updatedOn,
    categoryData,
    productId,
    priceTable,
    ratingTable,
    altFooter,
  } = props;
  const footerDataPresent =
    content ||
    faqsData?.length ||
    priceRateMerge ||
    priceTable ||
    alsoSearchFor;
  return (
    <FooterContainer
      ref={bottomRef}
      hideHeader={showHeader === '-56px' ? true : false}
    >
      <StoreFooter
        priceRateMerge={priceRateMerge}
        faqsData={faqsData}
        content={content}
        alsoSearchFor={alsoSearchFor}
        screen={screen}
        updatedOn={updatedOn}
        categoryData={categoryData}
        footerDataPresent={footerDataPresent}
        ratingTable={ratingTable}
        priceTable={priceTable}
        productId={productId}
        altFooter={altFooter}
      />
    </FooterContainer>
  );
}
